import FaqPage from "~/components/Faq/FaqPage";

const Faq = () => {
  return (
    <FaqPage
      description={
        "A list of Frequently Asked Questions (FAQs) from our users to support their use of RealEstateAgents.com."
      }
    />
  );
};

export default Faq;
